<app-page-wrapper
  [useBackBtn]="true"
  [useHeader]="true"
  [useFooter]="true"
  [title]="title"
  [subtitle]="subtitle"

>
  <ion-content>
    <div class="step-online-credit" *ngIf="loaded$ | async">
      <div class="form-wrapper">
        <app-payment-form
                [formFieldsList]="userFormFieldList"
                [formGroup]="userFormGroup"
                [readOnly]="fillAdditionalPersonalData"
        >
        </app-payment-form>
      </div>
      <div class="additional-form" *ngIf="additionalDataFormGroup">
        <div class="form-wrapper" [formGroup]="addressFormGroup">
          <app-payment-form
                  *ngIf="additionalDataFormGroup?.controls.address"
                  [formGroup]="addressFormGroup"
                  [formFieldsList]="additionalDataFormFieldList.address"
          >
          </app-payment-form>
          <app-form-checkbox option="Иной" formControlName="addressNotEqual"></app-form-checkbox>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Сведения о ранее выданных паспортах <span
                  style="font-size: 12px;">( образца 1997 года )</span></div>
          <div class="form-row">
            <app-payment-form
                    *ngIf="additionalDataFormGroup?.controls.prevDock"
                    [formGroup]="prevDocFormGroup"
                    [formFieldsList]="additionalDataFormFieldList.prevDock"
            >
            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Данные о месте работы</div>
          <div class="new-online-credit-form__column">
            <app-payment-form
                    *ngIf="additionalDataFormGroup?.controls.employer"
                    [formGroup]="employerFormGroup"
                    [formFieldsList]="additionalDataFormFieldList.employer"
            >
            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Стаж работы на последнем месте</div>
          <div class="new-online-credit-form__column">
            <app-payment-form
                    *ngIf="additionalDataFormGroup?.controls.work"
                    [formGroup]="workFormGroup"
                    [formFieldsList]="additionalDataFormFieldList.work"
            >
            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Данные о семейном положении</div>
          <div class="new-online-credit-form__column">
            <app-payment-form
                    *ngIf="additionalDataFormGroup?.controls.marital"
                    [formGroup]="maritalFormGroup"
                    [formFieldsList]="additionalDataFormFieldList?.marital"
                    [update]="updateMaritalFormFields">
              >

            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper" [formGroup]="rulesFormGroup">
          <app-form-checkbox
                  formControlName="agreeRules"
                  [option]="agreeRules.title"
                  [textData]="agreeRules.text"
          ></app-form-checkbox>

          <app-form-checkbox
                  formControlName="agreeInsurance"
                  [option]="agreeInsurance.title"
                  [textData]="agreeInsurance.text"
          ></app-form-checkbox>


          <app-form-checkbox
                  formControlName="agreeDebt"
                  [option]="agreeDebt.title"
                  [textData]="agreeDebt.text"
          ></app-form-checkbox>
        </div>
      </div>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loaded$ | async">
    <ion-button expand="block" ripple-effect class="button primary-light block"
                *ngIf="!fillAdditionalPersonalData" (click)="personalDataChanged()">
      Данные изменились
    </ion-button>
    <ion-button expand="block" ripple-effect class="button primary block"
                [disabled]="(userFormGroup && userFormGroup.invalid) || (additionalDataFormGroup  && additionalDataFormGroup.invalid)"
                (click)="handleOnPrimaryButtonClick()">
      Далее
    </ion-button>
    <ion-button expand="block"
                class="button primary-light"
                ripple-effect
                (click)="abort()"
    >
      Отмена
    </ion-button>
  </ng-container>


</app-page-wrapper>



